import styled from "styled-components";
// Path assumes this file lives at
// src/components/sections/WelcomeScreen/Summary/SummaryStep.styles.js
import { DIET_C } from "../../../common/colors";

// ═══════════════════════════════════════════════════════════════════════════════
// SUMMARY STEP
// Reuses the --c-*/--sp-*/--r-sm/--t-fast custom properties that
// AssessmentStepShell.styles.js's <Section> scopes over the whole step —
// this file never redeclares them, same as every other *Step.styles.js.
// ═══════════════════════════════════════════════════════════════════════════════

export const SectionStack = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--sp-4);
`;
SectionStack.displayName = "SectionStack";

export const SectionCard = styled.div`
  border: 1px solid ${DIET_C.secondary}55;
  border-radius: var(--r-sm);
  background: var(--c-surface);
  padding: var(--sp-4) var(--sp-5);
`;
SectionCard.displayName = "SectionCard";

export const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: var(--sp-3);
`;
SectionHeader.displayName = "SectionHeader";

export const SectionTitle = styled.h3`
  margin: 0;
  color: var(--c-text);
  font-size: 1rem;
  font-weight: 700;
`;
SectionTitle.displayName = "SectionTitle";

export const EditButton = styled.button`
  border: none;
  background: none;
  color: var(--c-primary);
  font-size: 0.85rem;
  font-weight: 700;
  cursor: pointer;
  padding: var(--sp-1) var(--sp-2);
  border-radius: var(--r-sm);
  transition: background var(--t-fast);

  &:hover {
    background: ${DIET_C.secondary}22;
  }

  &:focus-visible {
    outline: 3px solid var(--c-accent);
    outline-offset: 2px;
  }
`;
EditButton.displayName = "EditButton";

export const RowGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: var(--sp-2) var(--sp-5);

  @media (max-width: 30em) {
    grid-template-columns: 1fr;
  }
`;
RowGrid.displayName = "RowGrid";

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  gap: var(--sp-3);
  font-size: 0.88rem;
  padding: var(--sp-1) 0;

  @media (max-width: 30em) {
    justify-content: flex-start;
    flex-direction: column;
    gap: 2px;
  }
`;
Row.displayName = "Row";

export const RowLabel = styled.span`
  color: var(--c-text-muted);
`;
RowLabel.displayName = "RowLabel";

export const RowValue = styled.span`
  color: var(--c-text);
  font-weight: 600;
  text-align: right;

  @media (max-width: 30em) {
    text-align: left;
  }
`;
RowValue.displayName = "RowValue";

export const EmptyState = styled.p`
  margin: 0;
  color: var(--c-text-muted);
  font-size: 0.88rem;
  font-style: italic;
`;
EmptyState.displayName = "EmptyState";

// Shown when a required section is missing (defensive completeness check —
// see SummaryStep.validation.js). Amber/accent, not red: nothing has
// failed yet, the user just isn't done.
export const ValidationNotice = styled.p`
  margin: var(--sp-2) 0 0;
  color: ${DIET_C.accent};
  font-size: 0.85rem;
  font-weight: 600;
`;
ValidationNotice.displayName = "ValidationNotice";

// Shown when the Generate Diet Plan submission itself fails (network error,
// or the /generateDietPlan API rejecting the request) — distinct from
// ValidationNotice above, and in the error color since this is an actual
// failure, not an incomplete-form nudge.
export const ApiErrorNotice = styled.p`
  margin: var(--sp-2) 0 0;
  color: ${DIET_C.error};
  font-size: 0.85rem;
  font-weight: 600;
`;
ApiErrorNotice.displayName = "ApiErrorNotice";